/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library imports
import { Component, useEffect, lazy, Suspense } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

// project imports
import { Loader } from 'shared/hoc/loader/Loader';
import { BreadcrumbsManager } from 'shared/hoc/breadcrumbs/Breadcrumbs';
import { isAuthenticated, isAuthorized } from 'shared/settings/auth';

import store from 'features/store';
import { CategoryService, ItemsService } from 'shared/services';
import pmservice from 'shared/services/pmservice';

const AdminLogin = lazy(() => import('features/components/admin-login/AdminLogin'));
const ForgotPassword = lazy(() => import('features/components/forgot-password/ForgotPassword'));
const VerifyEmail = lazy(() => import('features/components/verify-email/VerifyEmail'));
const NotFound = lazy(() => import('features/components/redirect/NotFound'));
const AppLayout = lazy(() => import('features/components/base/layouts/AppLayout'));

const RouterChange = (props) => {

    useEffect(() => {
        store.dispatch({ type: 'ROUTE_CHANGE', payload: props.location.pathname });
    }, [props.location.pathname]);

    return null;
};

export class FeaturesRouter extends Component {

    constructor(props) {
        super(props);

        this.state = {
            page: false
        };
    }
    componentDidMount() {
        this.getPageLoadApis();
    }

    // preloadAssets = () => {
    //     // 👇 Preload the image immediately
    //     const link = document.createElement('link');
    //     link.rel = 'preload';
    //     link.as = 'image';
    //     link.href = homeBg;
    //     link.fetchPriority = 'high';
    //     document.head.appendChild(link);
    // };

    getPageLoadApis = () => {
        Promise.all([isAuthenticated(this.props.history), CategoryService.getCategorySelectionList(), pmservice.getMultipleContent(['homebanner', 'privacy-policy']), this.getFeaturedItem()]).then((responses) => {

            store.dispatch(({ type: 'CATEGORY', payload: this.formatCategorySelectionData(responses[1].data.data.data) }));
            
            let bannerContent = {};
            if ( Array.isArray(responses[2]?.data?.data) ) {

                const contentList = responses[2]?.data?.data;

                const bannerData = contentList.find(elem => elem.screenname === 'homebanner');
                const privacyPolicyData = contentList.find(elem => elem.screenname === 'privacy-policy');

                if ( bannerData ) {
                    bannerContent = JSON.parse(bannerData.jsoncontent);

                    // 👇 Preload the image immediately
                    const link = document.createElement('link');
                    link.rel = 'preload';
                    link.as = 'image';
                    link.href = bannerContent.bgimage;
                    link.fetchPriority = 'high';
                    document.head.appendChild(link);

                    store.dispatch(({ type: 'HOMEBANNER', payload: bannerContent }));
                }

                if ( privacyPolicyData ) {
                    store.dispatch(({ type: 'PRIVACY_POLICY', payload: JSON.parse(privacyPolicyData.jsoncontent) }));                    
                }
            }

            store.dispatch(({ type: 'MULTI_LIST', payload: responses[3]}));
            this.setState({ page: true });
        }).catch(error => {
            this.setState({ page: true });
        });
    }

     getFeaturedItem = () => {
        const payload = {
            "sort": [{ "field": "id", "direction": "asc" }],
            "field": ["itemid", "title", "itemdisplayurl", "itemtypeid", "status","saleid","itemseourl","thumbnailurl"],
        };
        return new Promise((resolve, reject) => {
            ItemsService.getshopwithItemList(payload).then(response => {
                resolve(response.data.data);
            }).catch((error) => {
                reject(error);
            });
        })
    }
    formatCategorySelectionData = (categorySelectionData) => {
        let categoryList = [];
        categorySelectionData.forEach((element, index) => {
            const parentId = (index + 1).toString();
            const category = { id: parentId, label: element.category, type: 'category', subCategory: [], active: false };
            element.selection.forEach((subElement, index) => {
                category.subCategory.push({ id: parentId + (index + 1), label: subElement.subcategory, type: 'subcategory', active: false });
            });

            categoryList.push(category);
        });

        return categoryList;
    };

    render() {
        return (this.state.page ?
            <Suspense fallback={<Loader />}>
                <RouterChange {...this.props} />
                <BreadcrumbsManager {...this.props} />
                <Switch>
                    <Route exact path="/admin">
                        {
                            isAuthorized() ? <Redirect to="/" /> : <AdminLogin {...this.props} />
                        }
                    </Route>
                    <Route exact path="/forgot-password">
                        {
                            isAuthorized() ? <Redirect to="/" /> : <ForgotPassword {...this.props} />
                        }
                    </Route>
                    <Route exact path="/verify-email">
                        {
                            () => {
                                return isAuthorized(true) ? <Redirect to="/" /> : <VerifyEmail {...this.props} />
                            }
                        }
                    </Route>
                    <Route>
                        {
                            <AppLayout {...this.props} />
                        }
                    </Route>
                    <Route exact path="/not-found" component={NotFound} />

                    <Redirect to="/" />
                </Switch>
            </Suspense> :
            <div className="pre-loader">
                <Loader />
            </div>
        );
    }
}
